export type PeriodKey = "7d" | "30d" | "90d";

const OPTIONS: { key: PeriodKey; label: string }[] = [
  { key: "7d", label: "7 dias" },
  { key: "30d", label: "30 dias" },
  { key: "90d", label: "90 dias" },
];

interface PeriodSwitcherProps {
  value: PeriodKey;
  onChange: (next: PeriodKey) => void;
}

/** Segmented control for picking the comparison window on admin pages. */
export function PeriodSwitcher({ value, onChange }: PeriodSwitcherProps) {
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-surface p-0.5">
      {OPTIONS.map((opt) => {
        const active = opt.key === value;
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            aria-pressed={active}
            className={`rounded-full px-3 py-1 text-xs font-medium tracking-tight transition-colors ${
              active
                ? "bg-surface-alt text-text"
                : "text-text-tertiary hover:text-text"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
